import { render, staticRenderFns } from "./ResetPasswordComplete.vue?vue&type=template&id=70190d8a&scoped=true&"
import script from "./ResetPasswordComplete.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordComplete.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordComplete.vue?vue&type=style&index=0&id=70190d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70190d8a",
  null
  
)

export default component.exports